import React, { useState } from 'react';

function Help ({setShowHelp}) 
{
  return (
    <div className="help-wrapper">
        <button className="buttonHelp" onClick={e => { setShowHelp(true)}}></button>
    </div>
  )
}

export default Help;